export const DocumentsTab = () => {
  return <div>Documents placeholder</div>;
};
